export default {"src":"/_next/static/media/openArrowIcon.95693359.svg","height":6,"width":10,"blurWidth":0,"blurHeight":0};